import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { AuditSampleModel } from "./audit-sample.model";
import { Observable } from "rxjs";

@Injectable()
export class AuditSamplerDataService extends ApiDataService {
    constructor() {
        super("controls/testing/advanced/audit/samples");
    }

    calculateSample(sample: AuditSampleModel): Observable<string[]> {
        return this.post<string[]>(sample);
    }
}
